import { useState, useEffect } from 'react';
import useAuthenticatedApi from '../../../Authentication/components/hooks/useAuthenticatedApi';

export interface PhotoEngineerStats {
    totalOrganizations: number;
    totalActivations: number;
    totalMediaUploads: number;
    totalShares: number;
    activationsToday: number;
    mediaUploadsToday: number;
    sharesToday: number;
}

export default function usePhotoEngineerStats(days: number = 30) {
    const [data, setData] = useState<PhotoEngineerStats | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const api = useAuthenticatedApi();

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await api.get(
                    `/photo-engineers/stats?days=${days}`,
                );
                setData(response.data);
            } catch (error) {
                console.error('Error fetching photo engineer stats:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [api, days]);

    return { data, isLoading };
}
